import HowSection from './HowSection'

export default HowSection
